export default __webpack_public_path__ + "static/media/pizza-sharing-animate.fdccf2ab.svg";